import React, { useEffect } from 'react';
import PriceBlock from './PriceBlock';

function CarForm(props) {
  useEffect(() => {
    if (props.step === 2) {
      props.addToDataLayer('step2');
    }
  }, [props.step]);

  const renderCheckBox = () => {
    if (props.carPriceChecked) {
      // checked
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" stroke="#0A994A" />
          <path d="M13.7188 6.00049L7.44948 12.0005L4.49924 9.17696" stroke="#0A994A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      );
    } else {
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" stroke="#0A994A" /></svg>
      );
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    props.sendCarInfo();
    // window.gtag('event', 'click', { 'event_category': 'button1' });
  }

  return (
    <div className={props.step === 2 ? 'kasco__estimate_value kasco_item kasco_message show' : 'kasco__estimate_value kasco_item kasco_message'}>
      <div className="item-head">
        <h2>{props.strings.title3} </h2>
      </div>
      {props.notFound && (
        <div className="message flex">
          <div className="ico flex flex_j-center">
            <svg width={3} height={13} viewBox="0 0 3 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.76136 0V5.05506C2.76136 5.5971 2.73011 6.13619 2.66761 6.67233C2.60511 7.20258 2.52273 7.74462 2.42045 8.29844H0.630682C0.528409 7.74462 0.446023 7.20258 0.383523 6.67233C0.321023 6.13619 0.289773 5.5971 0.289773 5.05506V0H2.76136ZM0 11.4888C0 11.2767 0.0369319 11.0793 0.110795 10.8967C0.190341 10.714 0.295455 10.555 0.426136 10.4194C0.5625 10.2839 0.721591 10.1779 0.903409 10.1013C1.08523 10.0188 1.28409 9.97757 1.5 9.97757C1.71023 9.97757 1.90625 10.0188 2.08807 10.1013C2.26989 10.1779 2.42898 10.2839 2.56534 10.4194C2.7017 10.555 2.80682 10.714 2.88068 10.8967C2.96023 11.0793 3 11.2767 3 11.4888C3 11.7009 2.96023 11.9012 2.88068 12.0897C2.80682 12.2724 2.7017 12.4315 2.56534 12.567C2.42898 12.7025 2.26989 12.8085 2.08807 12.8851C1.90625 12.9617 1.71023 13 1.5 13C1.28409 13 1.08523 12.9617 0.903409 12.8851C0.721591 12.8085 0.5625 12.7025 0.426136 12.567C0.295455 12.4315 0.190341 12.2724 0.110795 12.0897C0.0369319 11.9012 0 11.7009 0 11.4888Z" fill="#374656" />
            </svg>
          </div>
          <p>{props.strings.notFound}</p>
        </div>
      )}

      <form onSubmit={(e) => submitHandler(e)} className="form_kasco__estimate_value form_kasco">
        <div className="item-body">
          <PriceBlock
            strings={props.strings}
            marketPrice={props.marketPrice}
            marketPriceUah={props.marketPriceUah}
            isLoadingMarketPrice={props.isLoadingMarketPrice}
            carsData={props.carsData}
          />
          <div className="right-block">
            <div className="form-inline">
              <div
                className={(props.hasError && props.carsData.car_name === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}
              >
                <label>Марка авто<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val"
                  data-live-search="true"
                  title={props.strings.selectCar}
                  name="car_name"
                  value={props.carsData.car_name}
                >
                  {props.carsOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>
              <div className={(props.hasError && props.carsData.car_model === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>Модель авто<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val model-select"
                  data-live-search="true"
                  title={props.strings.selectModel}
                  name="car_model"
                  value={props.carsData.car_model}
                  disabled={!props.carsData.car_name}
                >
                  {props.modelsOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>
            </div>{/* form-inline */}
            <div className="form-inline">
              <div className={(props.hasError && props.carsData.car_year < 2009) ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>{props.strings.year}<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val without-search"
                  title={props.strings.selectTitle}
                  name="car_year"
                  value={props.carsData.car_year}
                >
                  {props.yearsOptions}
                </select>
                <div className="validation">{props.strings.minYear}</div>
              </div>
              <div className={(props.hasError && props.carsData.car_fuel === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>{props.strings.fuelType}<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val without-search"
                  title={props.strings.selectTitle}
                  name="car_fuel"
                  value={props.carsData.car_fuel}
                >
                  {props.fuelsOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>

            </div>{/* form-inline */}
            <div className="form-inline">
              <div className={(props.hasError && props.carsData.region === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>{props.strings.region}<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val"
                  data-live-search="true"
                  title={props.strings.selectTitle}
                  name="region"
                  value={props.carsData.region}
                >
                  {props.regionsOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>
              <div className={(props.hasError && props.carsData.city === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>{props.strings.city}<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val"
                  data-live-search="true"
                  title={props.strings.selectTitle}
                  name="city"
                  value={props.carsData.city}
                  disabled={!props.carsData.region}
                >
                  {props.citiesOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>

            </div>{/* form-inline */}
            <div className="form-inline">
              {/* distance */}
              <div className={(props.hasError && props.carsData.car_distance === '') ? 'form-group val-gr group-inval age-f validation-error' : 'form-group val-gr group-inval age-f'}>
                <label>{props.strings.distance}<span className="mnone">*</span></label>
                {/*<div className="range-slider">*/}
                  <input
                    onChange={props.handleInputs}
                    type="number"
                    step={0.1}
                    name="car_distance"
                    className="form-control age"
                    placeholder="0"
                    value={props.carsData.car_distance}
                  />
                  {/*<input id="range-milage" type="text" className="js-range-slider" defaultValue />*/}
                {/*</div>*/}
                <div className="validation">{props.strings.needed}</div>
              </div>
              {/* End distance */}

              {/* transmission */}
              <div className={(props.hasError && props.carsData.car_trans === '') ? 'form-group form-select form-select_search val-gr validation-error' : 'form-group form-select form-select_search val-gr'}>
                <label>{props.strings.trans}<span className="mnone">*</span></label>
                <select
                  onChange={props.handleInputs}
                  className="selectpicker form-val without-search"
                  title={props.strings.selectTitle}
                  name="car_trans"
                  value={props.carsData.car_trans}
                >
                  {props.transmissionsOptions}
                </select>
                <div className="validation">{props.strings.needed}</div>
              </div>
              {/* End transmission */}
            </div>{/* form-inline */}

            <div className="form-inline">
              {/* engine */}
              <div className="form-group form-select range-ov range-engine">
                <label>{props.strings.engine}</label>
                {/*<div className="range-slider">*/}
                  <input
                    onChange={props.handleInputs}
                    type="number"
                    step={0.1}
                    name="car_engine"
                    className="form-control age"
                    placeholder="0"
                    value={props.carsData.car_engine}
                  />
                  {/*<input id="range-volume" type="text" className="js-range-slider" defaultValue />*/}
                {/*</div>*/}
              </div>
              {/* End engine */}

              {/* carNumber */}
              <div className="form-group form-select form-select_search val-gr">
                <label>{props.strings.number}</label>
                <input
                  className="form-control"
                  type="text"
                  maxLength="8"
                  placeholder={props.strings.selectNumber}
                  id="input_number"
                  value={props.carNumber}
                  onChange={props.handleChangeCarNumber}
                />
              </div>
              {/* End carNumber */}

              {/* client Price */}
            </div>{/* form-inline */}
            <div className="form-inline">
              <div className={(props.hasError && (props.clientPrice ? props.clientPrice < 1 || props.clientPrice > 10000000 : true)) ? 'form-group val-gr group-inval age-f validation-error' : 'form-group val-gr group-inval age-f'}>
                <label>{props.strings.clientPrice}, $*</label>
                <input
                  onChange={props.handleChangeMarketPrice}
                  type="number"
                  step={0.1}
                  name="car-price"
                  className="form-control age"
                  placeholder="0"
                  value={props.carPriceChecked ? props.clientPrice : props.marketPrice ? props.marketPrice : ''}
                  disabled={!props.carPriceChecked && props.marketPrice}
                />
                <div className="validation">{props.strings.minPriceCar}</div>
              </div>
              {
                props.marketPrice === '' || props.marketPrice === 0 ? null : (
                  <div className="form-group form-select_search val-gr" onClick={props.checkBoxChange}>
                    <div className='flex' style={{ cursor: 'pointer' }}>
                      {renderCheckBox()}
                      <p className='checkbox-car-price'>{props.strings.agree}</p>
                    </div>
                  </div>
                )
              }
            </div>{/* form-inline */}
          </div>
        </div>
        <div className="item-footer">
          <div className="btn btn-back" onClick={props.prevStep}><div data-id="kasco_default"><svg width={6} height={10} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>{props.strings.back}</div></div>
          <div className={props.loading ? 'btn-valid btn-disabled disabled' : 'btn-valid'}>
            <button className="btn btn-bg btn-next" disabled={props.loading}>
              <div data-id="kasco_calculation">{props.strings.continue}</div>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CarForm;
